export interface WeChatPeopleMap{
    [id:string]:WeChatPeople;
}

export interface WeChatPeople{
    name:string,
    headUrl:string
}

export interface WeChatChitChatMap{
    [id:string]:WeChatChitChat;
}

export interface WeChatChitChatMapMap{
    [id:string]:WeChatChitChatMap;
}

export interface WeChatLinkChats{
    [id:string]:WeChatChitChat[];
}

export interface WeChatLink{
    people:string,
    chats:WeChatChitChat[]
}

export interface WeChatLinkMap{
    [id:string]:WeChatLink;
}

export interface WeChatChitChat{
    id:string,
    peopleId:string,
    chooses:WeChatChitChatChoose[]
}

export interface WeChatSaveChat{
    peopleId: string,
    /** 聊天组id */
    chatsId: string,
    /** 聊天id */
    chatId: string,
    /** 聊天选择 */
    chatChoose: number,
    /** 是否已领取 */
    bRecv: boolean,
    /** 是否观看过广告 */
    bLookAd?: boolean;
}

export interface WeChatChitChatChoose{
    chat:string,
    watchAdFlag ?: boolean;
    param:WeChatChitChatParam,
}

export interface WeChatChitChatParam{
    [key:string]:any
}

export interface WeChatManagerPeople{
    peopleId:string,
    peopleChatLinkQueue:string[],
    peopleChatLastLink:WeChatSaveChat[],
    bNewChat: boolean,
}

export enum WeChatEvent{
    UPDATEWECHATMAIN = "weChatMain.updateMain",
    USERUPDATEHEAD = "UserNode.updateHead"
}
